import {
  Typography,
  Card,
  CardMedia,
  CardContent,
  Stack,
  Button,
} from "@mui/material";
import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { Link } from "react-router-dom";

// HomeCard component to display product details on the homepage
const HomeCard = ({ product }) => {
  const { userState, dispatch } = useContext(UserContext);

  // Function to handle adding a product to the cart
  const handleAdd = () => {
    dispatch({
      type: "addToCart",
      payload: product,
    });
  };

  return (
    <Card sx={{ height: "430px" }}>
      {/* Clicking the image navigates to the product details page */}
      <Link to={`/product/${product.id}`}>
        <CardMedia
          component="img"
          image={product.images[0]} // Display the first product image
          alt={product.title}
          sx={{ height: "250px" }}
        />
      </Link>
      <CardContent
        sx={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
        }}
      >
        {/* Clicking the title navigates to the product details page */}
        <Link
          to={`/product/${product.id}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Typography
            color="primary"
            variant="body1"
            sx={{
              fontWeight: "bold",
              marginBottom: "10px",
              height: "25px",
              overflow: "hidden",
            }}
          >
            {product.title} {/* Display product title */}
          </Typography>
        </Link>

        {/* Product description with ellipsis for long texts */}
        <Typography
          variant="body2"
          sx={{
            WebkitLineClamp: 3, // Limit text to 3 lines
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            minHeight: "50px",
          }}
        >
          {product.description}
        </Typography>

        {/* Price and Add to Cart button */}
        <Stack
          sx={{
            marginTop: "40px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontWeight: "bold", color: "#A5AAB5" }}>
            ${product.price} {/* Display product price */}
          </Typography>
          {/* Show "Add to Cart" button only if the user is logged in */}
          {userState?.username && (
            <Button onClick={handleAdd}>Add To Cart</Button>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default HomeCard;
